const checkScrollerWidth = (scroller) => {
    const scrollerWidth = scroller.scrollWidth;

    if (window.innerWidth - 60 <= scrollerWidth) {
        scroller.classList.add('plan-table__scroller--edged');
    } else {
        scroller.classList.remove('plan-table__scroller--edged');
    }
}

(function ($, document, window) {
    'use strict';

    $(function () {
        const planTables = document.querySelectorAll('.js-plan-table');

        planTables.forEach((planTableSystem) => {
            const scroller = planTableSystem.querySelector('.js-plan-table-scroller');

            checkScrollerWidth(scroller);

            window.addEventListener('resize', () => {
                setTimeout(() => {
                    checkScrollerWidth(scroller);
                }, 300);
            });
        });
    });
})(jQuery, document, window);
